export const getIdentityName = (identity) =>
  `${identity.firstName} ${identity.lastName}`

export const getIdentityInitials = (identity) =>
  `${identity.firstName[0]}${identity.lastName[0]}`
